$ ->
  $(document)
    .on 'click', '.popover-header-menu .js-feature-migrated', (e) ->
      $target = $(e.currentTarget)
      migratedFeature = $target.data('migrated-feature')

      if migratedFeature == 'team-stats'
        content = """
          <div class="migrated-feature-popover-content">
            <div class="migrated-feature-popover-content-image" data-feature="dashboard-delay-statistics"></div>
            <h6 class="migrated-feature-popover-content-title">团队统计已升级为<br>全新成员延误率统计</h6>
            <p class="migrated-feature-popover-content-text">我们更换了全新界面，增加了按时间和成员筛选功能，你可以前往鹰眼进行查看。</p>
          </div>
          <div class="migrated-feature-popover-actions">
            <a href="javascript:;" class="btn btn-primary btn-large js-close-popover">知道了</a>
          </div>
        """

        simple.popover
          pointTo: $('#nav-dashboard > a')
          content: content
          offset:
            y: -10
          position: 'bottom-center'
    .on 'click', '.migrated-feature-popover-actions .js-close-popover', (e) ->
      $(e.currentTarget).closest('.simple-popover').data('popover').destroy()
